/**
 * editor2/shared/SectionHeader.tsx
 * セクションタイトルコンポーネント
 * VehicleDetailPanel の gc-section-title パターンに準拠
 */
import React from 'react';

interface SectionHeaderProps {
  title: string;
}

export default function SectionHeader({ title }: SectionHeaderProps) {
  return (
    <div
      className="gc-section-title"
      style={{
        fontWeight: 'bold',
        borderBottom: '1px solid #eee',
        paddingBottom: 4,
        marginTop: 8,
      }}
    >
      {title}
    </div>
  );
}
